var _circle, _g, _g2, _path, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F917(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 30.001,
    r: 28
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF717F"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-75.001 49.953 21.546)",
    opacity: 0.8,
    cx: 49.953,
    cy: 21.544,
    rx: 6.067,
    ry: 8.401
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-124.995 12.269 28.189)",
    opacity: 0.8,
    cx: 12.268,
    cy: 28.188,
    rx: 6.067,
    ry: 8.399
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.744 18.153c-2.453-4.251-5.342-6.084-7.832-5.646-2.488.438-4.576 3.15-5.427 7.983-.081.486.915 1.161 1.262.637 1.304-1.972 3.101-2.98 5.096-3.333 2-.353 4.035-.019 5.934 1.388.504.375 1.211-.599.967-1.029zM46.176 14.728c-2.455-4.25-5.342-6.085-7.832-5.646-2.488.438-4.576 3.15-5.426 7.983-.086.486.912 1.16 1.26.637 1.303-1.972 3.098-2.98 5.098-3.334 2-.353 4.033-.018 5.932 1.389.503.374 1.212-.6.968-1.029z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M42.93 26.516c-6.318 6.294-14.32 7.675-22.361 3.942-.969-.451-1.564.728-.809 1.586 2.816 3.213 7.787 5.635 13.434 4.64 5.645-.995 9.488-4.971 11.039-8.954.413-1.066-.547-1.97-1.303-1.214z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.168 46.827s1.83-.576 1.125-2.992c-.73-2.504-6.902 0-9.977-1.17 0 0 2.532-.787 1.659-2.889-.793-1.906-7.649-2.553-14.293 2.551-6.725 5.164-2.346 17.152 5.942 18.629 5.788 1.029 14.603.859 15.718-1.629.889-1.988-1.904-2.746-1.904-2.746s3.543-.021 3.543-2.686c0-1.557-1.334-1.576-1.334-1.576s2.92-.432 2.92-3.137c-.001-2.191-3.399-2.355-3.399-2.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCFD4",
    d: "M28.371 46.86c2.236-1.475.334-5.107-2.361-4.656-2.299.385-6.287.379-6.287.379.006-.01 1.283-.514.961-2.193-.338-1.748-2.669-4.221-12.323-.287-3.568 1.455-5.938 4.506-6.306 8.199-.4 4.021 1.44 8.654 4.28 10.773 3.243 2.42 10.667 3.756 17.938 2.357 4.752-.914 4.27-3.99 2.299-4.512 3.254-.623 3.551-3.379 2.018-4.219 3.738-1.138 2.705-5.686-.219-5.841zm-2.576 5.122c-1.893.222-7.008.563-7.008.563s3.527.661 7.169.148c3.253-.458 3.108 2.839-1.524 3.449-2.204.291-5.72.352-5.72.352s3.157.544 4.878.319c4.406-.579 3.949 2.72-.25 3.306-7.296 1.017-13.24-.036-16.071-2.147-4.071-3.039-6.53-12.965 1.468-16.723 3.643-1.712 9.539-3.189 10.412-1.18 1.248 2.879-4.184 3.245-4.184 3.245s4.354.628 10.73-.122c1.738-.202 2.987 1.918.926 3.141-1.801 1.069-7.864 1.452-7.864 1.452s3.262.104 7.895-.279c3.73-.31 4.061 3.902-.857 4.476z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36.834 46.827s-1.832-.576-1.125-2.992c.73-2.504 6.9 0 9.977-1.17 0 0-2.531-.787-1.658-2.889.793-1.906 7.648-2.553 14.293 2.551 6.725 5.164 2.346 17.152-5.943 18.629-5.787 1.029-14.604.859-15.717-1.629-.889-1.988 1.904-2.746 1.904-2.746s-3.545-.021-3.545-2.686c0-1.557 1.336-1.576 1.336-1.576s-2.92-.432-2.92-3.137c0-2.191 3.398-2.355 3.398-2.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCFD4",
    d: "M35.41 52.702c-1.531.84-1.234 3.596 2.02 4.219-1.971.521-2.455 3.598 2.297 4.512 7.271 1.398 14.695.063 17.939-2.357 2.84-2.119 4.68-6.752 4.279-10.773-.367-3.693-2.736-6.744-6.305-8.199-9.654-3.934-11.984-1.461-12.322.287-.324 1.68.953 2.184.959 2.193 0 0-3.988.006-6.287-.379-2.695-.451-4.596 3.182-2.361 4.656-2.924.154-3.955 4.702-.219 5.841zm1.94-5.195c4.631.383 7.895.279 7.895.279s-6.064-.383-7.864-1.452c-2.062-1.223-.813-3.343.927-3.141 6.375.75 10.729.122 10.729.122s-5.433-.366-4.183-3.245c.872-2.01 6.768-.532 10.41 1.18 7.998 3.758 5.539 13.684 1.469 16.723-2.831 2.111-8.775 3.164-16.072 2.147-4.199-.586-4.655-3.885-.248-3.306 1.719.225 4.877-.319 4.877-.319s-3.516-.061-5.72-.352c-4.632-.61-4.776-3.907-1.524-3.449 3.643.513 7.169-.148 7.169-.148s-5.114-.342-7.009-.563c-4.919-.575-4.587-4.787-.856-4.476z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F917);
export default __webpack_public_path__ + "static/media/1f917.95982dc1e0174595639a8efbfe6368f7.svg";
export { ForwardRef as ReactComponent };